export default function getDatePickerTitle(label, value) {
    if (value && Array.isArray(value)) {
        return label;
    }
    return 'Select a Date';
}
